exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".pi-features__summary[data-v-0d7e2d4d]{display:flex;flex-wrap:wrap;gap:8px;margin-bottom:12px}.pi-features__chip[data-v-0d7e2d4d]{display:inline-flex;align-items:center;gap:6px;height:32px;padding:0 10px;border:1px solid #d9dde3;border-radius:16px;background:#fff;font-size:12px;color:#3a424e;cursor:pointer}.pi-features__chip.is-on[data-v-0d7e2d4d]{border-color:#1b59f8;box-shadow:0 0 0 1px #1b59f8}.pi-features__count[data-v-0d7e2d4d]{font-weight:700}.pi-features__chip-wrap[data-v-0d7e2d4d]{display:inline-flex;align-items:center;gap:4px}.pi-features__info[data-v-0d7e2d4d]{margin-left:4px}.pi-features__clear[data-v-0d7e2d4d]{padding-bottom:8px;font-size:12px}.pi-features__legend[data-v-0d7e2d4d]{margin-top:10px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-0d7e2d4d","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=1!./src/vue/pages/restricted/productIntelligence/piFeatures.vue
// module id = 1677
// module chunks = 0